module.exports = __webpack_public_path__ + "img/Product-Title.22d9dbac.png";